import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import ParameterForm from "components/parameters/ParameterForm";
import { createParameter } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const ParameterCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const parameter = {
    name: "",
    type: "",
    description: "",
    abbreviation: "",
    unit: "",
    defaultValue: "",
    values: [],
    companies: [me.companyID ?? ""],
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        type,
        description,
        abbreviation,
        unit,
        defaultValue,
        values,
        companies,
      } = valuesParam;

      await API.graphql({
        query: createParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            type,
            description,
            abbreviation,
            unit,
            defaultValue,
            values: JSON.stringify(values),
            companies,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/parameters");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <ParameterForm onSubmit={onSubmit} initialValues={parameter} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Parámetro",
    successAdded: "Parámetro agregado con éxito",
    responses: {},
  },
});

export default ParameterCreateForm;
